import * as React from 'react'

import { IconMailEmailLetter5, ShapeIcons } from '@creditas-ui/react'

function EmailSent(props) {
  return <ShapeIcons {...props} Icon={IconMailEmailLetter5} size="small" />
}

export { EmailSent }
